(function () {

  var translated = false;
  var observer = null;

  function translateCookieBanner() {
    if (translated) return;

    var banner = document.querySelector('#cb-cookie_consent');
    if (!banner) return;

    var textContainer = banner.querySelector('.cb-cookie_consent-container-text_container');
    var link = banner.querySelector('.cb-cookie_consent-container-link_container');
    var button = banner.querySelector('.cb-cookie_consent-container-button');

    if (!textContainer || !button) return;

    // テキスト差し替え
    textContainer.childNodes.forEach(function(node) {
      if (node.nodeType === 3 && node.nodeValue.trim() !== '') {
        node.nodeValue = 'This website uses cookies to improve our services and analyze site traffic. ';
      }
    });

    // リンクテキスト + URL差し替え
    if (link) {
      link.textContent = 'Learn more';

      var currentHref = link.getAttribute('href');
      if (currentHref && !currentHref.includes('/en-us/')) {
        link.setAttribute(
          'href',
          currentHref.replace('/policies/', '/en-us/policies/')
        );
      }
    }

    // ボタン
    button.textContent = 'Accept';

    translated = true;

    if (observer) {
      observer.disconnect();
    }
  }

  // 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateCookieBanner);
  } else {
    translateCookieBanner();
  }

  // 後から出るバナー対策
  observer = new MutationObserver(function () {
    translateCookieBanner();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();